import React from 'react';
import PropTypes from 'prop-types';
import { UncontrolledTooltip } from 'reactstrap';
import { useIntl } from 'react-intl';

const AdminUsersList2FAIcon = ({ user }) => {
  const intl = useIntl();

  if (!user.g2fa_enabled) {
    return null;
  }

  return (
    <span id={`user-2fa-${user.uuid}`} className="user-2fa-enabled">
      <i className="fas fa-shield-check" />
      <UncontrolledTooltip target={`user-2fa-${user.uuid}`} fade={false}>
        {intl.formatMessage({ defaultMessage: 'Two-factor authentication enabled' })}
      </UncontrolledTooltip>
    </span>
  );
};

AdminUsersList2FAIcon.propTypes = {
  user: PropTypes.object.isRequired,
};

export default AdminUsersList2FAIcon;
